/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';
import PostItemData from './PostItemData';

/**
 * The CommunityControllerDtoPostDetailResponse model module.
 * @module model/CommunityControllerDtoPostDetailResponse
 * @version 1.0
 */
class CommunityControllerDtoPostDetailResponse {
    /**
     * Constructs a new <code>CommunityControllerDtoPostDetailResponse</code>.
     * @alias module:model/CommunityControllerDtoPostDetailResponse
     */
    constructor() { 
        
        CommunityControllerDtoPostDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostDetailResponse} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostDetailResponse} The populated <code>CommunityControllerDtoPostDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
            if (data.hasOwnProperty('readCount')) {
                obj['readCount'] = ApiClient.convertToType(data['readCount'], 'Number');
            }
            if (data.hasOwnProperty('receiveCount')) {
                obj['receiveCount'] = ApiClient.convertToType(data['receiveCount'], 'Number');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('initialPer')) {
                obj['initialPer'] = ApiClient.convertToType(data['initialPer'], 'Number');
            }
            if (data.hasOwnProperty('initialXper')) {
                obj['initialXper'] = ApiClient.convertToType(data['initialXper'], 'Number');
            }
            if (data.hasOwnProperty('depositTransactionStatus')) {
                obj['depositTransactionStatus'] = ApiClient.convertToType(data['depositTransactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('sentAt')) {
                obj['sentAt'] = ApiClient.convertToType(data['sentAt'], 'Date');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
            if (data.hasOwnProperty('per')) {
                obj['per'] = ApiClient.convertToType(data['per'], 'Number');
            }
            if (data.hasOwnProperty('xper')) {
                obj['xper'] = ApiClient.convertToType(data['xper'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('postType')) {
                obj['postType'] = ApiClient.convertToType(data['postType'], 'Number');
            }
            if (data.hasOwnProperty('eventNo')) {
                obj['eventNo'] = ApiClient.convertToType(data['eventNo'], 'Number');
            }
            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [PostItemData]);
            }
            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
            if (data.hasOwnProperty('depositPer')) {
                obj['depositPer'] = ApiClient.convertToType(data['depositPer'], 'Number');
            }
            if (data.hasOwnProperty('depositXper')) {
                obj['depositXper'] = ApiClient.convertToType(data['depositXper'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        if (data['items']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['items'])) {
                throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
            }
            // validate the optional field `items` (array)
            for (const item of data['items']) {
                PostItemData.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
CommunityControllerDtoPostDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
CommunityControllerDtoPostDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
CommunityControllerDtoPostDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
CommunityControllerDtoPostDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
CommunityControllerDtoPostDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} postNo
 */
CommunityControllerDtoPostDetailResponse.prototype['postNo'] = undefined;

/**
 * @member {String} title
 */
CommunityControllerDtoPostDetailResponse.prototype['title'] = undefined;

/**
 * @member {String} content
 */
CommunityControllerDtoPostDetailResponse.prototype['content'] = undefined;

/**
 * @member {Number} userCount
 */
CommunityControllerDtoPostDetailResponse.prototype['userCount'] = undefined;

/**
 * @member {Number} readCount
 */
CommunityControllerDtoPostDetailResponse.prototype['readCount'] = undefined;

/**
 * @member {Number} receiveCount
 */
CommunityControllerDtoPostDetailResponse.prototype['receiveCount'] = undefined;

/**
 * @member {Number} walletNo
 */
CommunityControllerDtoPostDetailResponse.prototype['walletNo'] = undefined;

/**
 * @member {Number} initialPer
 */
CommunityControllerDtoPostDetailResponse.prototype['initialPer'] = undefined;

/**
 * @member {Number} initialXper
 */
CommunityControllerDtoPostDetailResponse.prototype['initialXper'] = undefined;

/**
 * @member {Number} depositTransactionStatus
 */
CommunityControllerDtoPostDetailResponse.prototype['depositTransactionStatus'] = undefined;

/**
 * @member {Date} sentAt
 */
CommunityControllerDtoPostDetailResponse.prototype['sentAt'] = undefined;

/**
 * @member {Date} expireAt
 */
CommunityControllerDtoPostDetailResponse.prototype['expireAt'] = undefined;

/**
 * @member {Number} per
 */
CommunityControllerDtoPostDetailResponse.prototype['per'] = undefined;

/**
 * @member {Number} xper
 */
CommunityControllerDtoPostDetailResponse.prototype['xper'] = undefined;

/**
 * @member {Boolean} enabled
 */
CommunityControllerDtoPostDetailResponse.prototype['enabled'] = undefined;

/**
 * @member {Number} postType
 */
CommunityControllerDtoPostDetailResponse.prototype['postType'] = undefined;

/**
 * @member {Number} eventNo
 */
CommunityControllerDtoPostDetailResponse.prototype['eventNo'] = undefined;

/**
 * @member {Array.<module:model/PostItemData>} items
 */
CommunityControllerDtoPostDetailResponse.prototype['items'] = undefined;

/**
 * @member {String} walletAddress
 */
CommunityControllerDtoPostDetailResponse.prototype['walletAddress'] = undefined;

/**
 * @member {Number} depositPer
 */
CommunityControllerDtoPostDetailResponse.prototype['depositPer'] = undefined;

/**
 * @member {Number} depositXper
 */
CommunityControllerDtoPostDetailResponse.prototype['depositXper'] = undefined;






export default CommunityControllerDtoPostDetailResponse;

